import { render, staticRenderFns } from "./Jewel06_Dia.vue?vue&type=template&id=15e31bee&scoped=true&"
import script from "./Jewel06_Dia.vue?vue&type=script&lang=js&"
export * from "./Jewel06_Dia.vue?vue&type=script&lang=js&"
import style0 from "./Jewel06_Dia.vue?vue&type=style&index=0&id=15e31bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e31bee",
  null
  
)

export default component.exports